import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import AssignmentIndOutlinedIcon from 'components/material-symbol/icons/AssignmentInd'
import EditOutlinedIcon from 'components/material-symbol/icons/Edit'
import { PageHeader } from 'components/page-header'
import { formatNameForDisplay } from 'lib/text-display'
import RouterLinkButton from 'components/router-link-button'
import ParticipantInformation from './participant-information'
import hasNonNullProperty from 'lib/utils/has-non-null-property'

const accountActions = (hasCompletedProfile, currentUrl) => (
  <>
    <RouterLinkButton
      to={`${currentUrl}/profile/edit`}
      variant="outlined"
      color="primary"
      startIcon={<AssignmentIndOutlinedIcon />}
    >
      {hasCompletedProfile ? 'Edit Golfer Profile' : 'Complete Golfer Profile'}
    </RouterLinkButton>
    <RouterLinkButton
      to={`${currentUrl}/edit`}
      variant="contained"
      color="primary"
      startIcon={<EditOutlinedIcon fontSize="small" />}
    >
      Edit
    </RouterLinkButton>
  </>
)

export default function GolferAccount({ student, refetch }) {
  const { path, url: currentUrl } = useRouteMatch()
  const studentName = formatNameForDisplay(
    `${student?.firstName} ${student?.lastName}`,
  )
  const hasCompletedProfile = hasNonNullProperty(student?.golferProfile)

  const accountsListUrl = `${path
    .split('/')
    .slice(0, 2)
    .join('/')}/students`

  const crumbs = [
    {
      label: 'Accounts',
      to: accountsListUrl,
    },
    {
      label: studentName,
      to: currentUrl,
    },
  ]

  return (
    <Box style={{ minHeight: '100%', margin: 0, paddingBottom: 16 }}>
      <PageHeader
        title={studentName}
        crumbs={crumbs}
        backTo={accountsListUrl}
        actions={accountActions(hasCompletedProfile, currentUrl)}
        fixedMobileActions
        keepActionsInline
      />
      <ParticipantInformation
        participant={student}
        refetch={refetch}
        profileEditUrl={`${currentUrl}/profile/edit`}
      />
    </Box>
  )
}
